// Custom next/image loader.
//
// In local `npm run dev` the app talks to production (API calls are proxied to
// wvemedia.com), but nothing serves /image-upload on the dev host. Components
// that build relative upload paths (`/image-upload/...`) would otherwise be
// fetched from http://localhost:3000 and fail, so resolve those against
// production. Absolute localhost upload URLs are rewritten too as a safety net.
// Everything else falls through to the built-in optimizer untouched, including
// in production builds.
//
// NOTE: next.config.js sets `loaderFile` WITHOUT `loader: "custom"` on purpose
// so the /_next/image optimization API stays enabled.

const PROD_IMAGE_ORIGIN = "https://wvemedia.com";

function resolveDevUploadSrc(src) {
  if (process.env.NODE_ENV === "production") return src;
  // Absolute localhost upload URL → swap origin for prod.
  if (/^https?:\/\/localhost(:\d+)?\/image-upload\//.test(src)) {
    return src.replace(/^https?:\/\/localhost(:\d+)?/, PROD_IMAGE_ORIGIN);
  }
  // Relative upload path → resolve against prod origin.
  if (src.startsWith("/image-upload/")) {
    return `${PROD_IMAGE_ORIGIN}${src}`;
  }
  return src;
}

export default function imageLoader({ src, width, quality }) {
  const resolvedSrc = resolveDevUploadSrc(src);
  return `/_next/image?url=${encodeURIComponent(resolvedSrc)}&w=${width}&q=${
    quality || 75
  }`;
}
